import React from 'react'

interface AsciiDividerProps {
  char?: string
  label?: string
  width?: number
}

export const AsciiDivider: React.FC<AsciiDividerProps> = ({
  char = '─',
  label,
  width = 60,
}) => {
  const color = 'var(--border-color, #2a2a2a)'

  if (!label) {
    const line = char.repeat(width)
    return (
      <div
        style={{
          color,
          fontFamily: "'JetBrains Mono', 'Courier New', monospace",
          fontSize: '0.85rem',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          userSelect: 'none',
          margin: '1.5rem 0',
        }}
        aria-hidden="true"
      >
        {line}
      </div>
    )
  }

  const labelStr = ` [ ${label} ] `
  const sideLength = Math.max(0, Math.floor((width - labelStr.length) / 2))
  const leftLine = char.repeat(sideLength)
  // Adjust right side to fill exactly `width` chars
  const rightLength = width - sideLength - labelStr.length
  const rightLine = char.repeat(Math.max(0, rightLength))

  return (
    <div
      style={{
        color,
        fontFamily: "'JetBrains Mono', 'Courier New', monospace",
        fontSize: '0.85rem',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        userSelect: 'none',
        margin: '1.5rem 0',
      }}
      aria-hidden="true"
    >
      <span>{leftLine}</span>
      <span style={{ color: 'var(--text-secondary, #888)' }}>{labelStr}</span>
      <span>{rightLine}</span>
    </div>
  )
}
